import { useAppContext } from "../../context/shared";

const BlogEmptyState = () => {
  const { localization } = useAppContext()
  return (
    <div className='d-flex flex-column justify-content-center align-items-center pb-5 pt-5'>
      <img alt='empty state' src='/images/blog_empty_state.png' />
      <h4 className='py-3'>{localization.blog_no_results}</h4>
      <div className='caption text-muted'>{localization.blog_no_results_helper}</div>
    </div>
  )
}

export default BlogEmptyState